export class FrameworkSettingsTeleEye {
    PAYMENT_GATEWAY:String;
}